import React from 'react';
import { FiX } from 'react-icons/fi';
import { getAllShortcuts } from '../../constants/keyboardShortcuts';

const ShortcutModal = ({ onClose }) => {
  const categories = getAllShortcuts();

  // 같은 action의 중복 제거 (displayKey 기준 첫 번째만)
  const dedup = (shortcuts) => {
    const seen = new Set();
    return shortcuts.filter((s) => {
      const key = `${s.action}_${s.displayKey}`;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  };

  return (
    <div
      style={{
        position: 'fixed', inset: 0, zIndex: 10000,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        backgroundColor: 'rgba(0,0,0,0.4)',
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: '#ffffff', borderRadius: '12px',
          boxShadow: '0 25px 50px -12px rgba(0,0,0,0.25)',
          width: '520px', maxHeight: '80vh', display: 'flex', flexDirection: 'column',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* 헤더 */}
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '16px 20px', borderBottom: '1px solid #e5e7eb',
        }}>
          <h2 style={{ margin: 0, fontSize: '16px', fontWeight: '600', color: '#1f2937' }}>
            키보드 단축키
          </h2>
          <button
            onClick={onClose}
            style={{
              border: 'none', background: 'none', cursor: 'pointer',
              color: '#6b7280', padding: '4px', borderRadius: '4px',
            }}
          >
            <FiX size={18} />
          </button>
        </div>

        {/* 내용 */}
        <div style={{ overflowY: 'auto', padding: '16px 20px' }}>
          {categories.map((cat) => (
            <div key={cat.category} style={{ marginBottom: '20px' }}>
              <div style={{
                fontSize: '13px', fontWeight: '600', color: '#3b82f6',
                marginBottom: '8px', paddingBottom: '4px', borderBottom: '2px solid #dbeafe',
              }}>
                {cat.category}
              </div>
              <div>
                {dedup(cat.shortcuts).map((s, i) => (
                  <div
                    key={`${s.action}-${i}`}
                    style={{
                      display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                      padding: '6px 0', borderBottom: '1px solid #f3f4f6',
                    }}
                  >
                    <span style={{ fontSize: '13px', color: '#374151' }}>
                      {s.description}
                    </span>
                    <kbd style={{
                      padding: '2px 8px', backgroundColor: '#f3f4f6', border: '1px solid #e5e7eb',
                      borderRadius: '4px', fontSize: '12px', fontFamily: 'monospace', color: '#1f2937',
                      whiteSpace: 'nowrap',
                    }}>
                      {s.displayKey}
                    </kbd>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ShortcutModal;
